import type { Notification, NotificationSummary, Page } from '@talkvibe/shared';
import { api } from './api.ts';

export const notificationService = {
  list: (cursor?: string): Promise<Page<Notification>> =>
    api.get<Page<Notification>>('/api/notifications', { query: { cursor } }),

  /** Just the badge count - cheaper than fetching a page of rows. */
  summary: (): Promise<NotificationSummary> =>
    api.get<NotificationSummary>('/api/notifications/summary'),

  markRead: (id: string): Promise<void> =>
    api.post(`/api/notifications/${encodeURIComponent(id)}/read`).then(() => undefined),

  markAllRead: (): Promise<void> =>
    api.post('/api/notifications/read-all').then(() => undefined),
};
